'use strict';

module.exports = locate;

function locate(value, fromIndex) {
  var index = value.indexOf('\n', fromIndex);

  while (index > fromIndex) {
    if (value.charAt(index - 1) !== ' ') {
      break;
    }

    index--;
  }

  return index;
}



//////////////////
// WEBPACK FOOTER
// ./~/remark-parse/lib/locate/break.js
// module id = 1372
// module chunks = 0